import { render, staticRenderFns } from "./TopNavBarPez.vue?vue&type=template&id=cb73a92c&"
import script from "./TopNavBarPez.vue?vue&type=script&lang=js&"
export * from "./TopNavBarPez.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "TopNavBarPez.vue"
export default component.exports